var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var JobSubscriber_1;
import { InjectorScope } from '@slickdeals/durango/dist/javascript/core/injector';
import { injectable } from '@slickdeals/durango/dist/javascript/decorators/injectable';
/**
 * Quality of Services levels that controls the delivery of jobs.
 * {@link https://www.hivemq.com/blog/mqtt-essentials-part-6-mqtt-quality-of-service-levels/}
 * */
export var QOSLevels;
(function (QOSLevels) {
    /** Jobs are broadcasted with no guarantees that they will be heard */
    QOSLevels["QOS0"] = "qos0";
    /** Jobs are broadcasted with a guarantee that they will be heard at least once */
    QOSLevels["QOS1"] = "qos1";
})(QOSLevels || (QOSLevels = {}));
/** Unique events announcing a subscription */
export const QOSSubscriptionEvents = {
    QOS1: `bp:qos:${QOSLevels.QOS1}`,
};
/** Name for this module */
export const name = 'JobSubscriber';
let JobSubscriber = JobSubscriber_1 = class JobSubscriber {
    static create() {
        return new JobSubscriber_1();
    }
    /**
     * Subscribe to an event based on topic and qos level
     * @param topic Topic of job
     * @param qos Quality of Service level
     * @param handler Handler to run when event fires
     */
    // eslint-disable-next-line class-methods-use-this
    async subscribe(topic, qos, handler) {
        document.addEventListener(topic, (event) => {
            handler(event.detail.job);
        });
        if (qos === QOSLevels.QOS1) {
            document.dispatchEvent(new CustomEvent(QOSSubscriptionEvents.QOS1, {
                detail: {
                    topic,
                },
            }));
        }
    }
};
JobSubscriber = JobSubscriber_1 = __decorate([
    injectable({
        key: name,
        scope: InjectorScope.Singleton,
    })
], JobSubscriber);
export default JobSubscriber;
